import Headers from "../../config/headers";
import ApiCalls from "../../config/apiCalls";
import localStorageFunc from "../../helpers/localStorageFunc";
import Utility from "../../helpers/utility";

export default {
  namespaced: true,
  state: {
    allOrderData: [],
    showTrackingShimmer: false,
    currentWidgetIndex: 0,
    activeOrders: {},
    resetInterval: [],
    showPendingOrderModal: false,
    orderStatus: {}
  },
  getters: {},
  mutations: {
    udpateOrderStatus(state, payload) {
      const { itemIndex, orderData } = payload;
      if (state.allOrderData.length <= itemIndex) {
        state.allOrderData = [...state.allOrderData, orderData];
        state.resetInterval.push(false);
      } else {
        state.allOrderData[itemIndex] = orderData;
        state.resetInterval[itemIndex] = false;
      }
    },
    updateAllOrderData(state, payload) {
      state.allOrderData = payload;
    },
    updateResetInterval(state, payload) {
      const { itemIndex, reset } = payload;
      state.resetInterval[itemIndex] = reset;
    },
    updateShowTrackingShimmer(state, payload) {
      state.showTrackingShimmer = payload;
    },
    updateCurrentWidgetIndex(state, payload) {
      state.currentWidgetIndex = payload;
    },
    updateActiveOrders(state, payload) {
      state.activeOrders = payload;
    },
    updateShowPendingOrderModal(state, payload) {
      state.showPendingOrderModal = payload;
      payload ? 
      document.body.classList.add("body-stop-scroll-mobile") :
      document.body.classList.remove("body-stop-scroll-mobile")
    },
    saveOrderStatus(state, payload) {
      state.orderStatus = payload;
    },
  },
  actions: {
    getOrderStatus({ commit, rootState, rootGetters }, payload) {
      const defaultHeaders = Headers();
      const { orderId, itemIndex } = payload;
      if (rootState.NxgTrackOrder?.currentWidgetIndex !== itemIndex) {
        // reset its interval if the widget index is not same as itemIndex
        commit("updateResetInterval", { itemIndex, reset: true });
        return;
      }
      const currOrderList = rootState.NxgTrackOrder?.allOrderData || [];
      let currentOrder = {};
      if (itemIndex < currOrderList.length)
        currentOrder = currOrderList?.[itemIndex];
      // if order is already delivered, no need to hit status API for that order anymore
      if (currentOrder.orderStatusCode == 9) return;
      if (currOrderList.length <= itemIndex) {
        commit("updateShowTrackingShimmer", true);
      }
      ApiCalls.ORDER_TRACKING_API({
        headers: {
          ...defaultHeaders,
          Mobile: localStorageFunc.getMobileNumber(),
        },
        payload: { orderId },
      })
        .then((res) => {
          if (res?.data) {
            commit("updateShowTrackingShimmer", false);
            commit(
              "udpateOrderStatus",
              { orderData: { ...res?.data, orderId: orderId }, itemIndex } || {}
            );
          }
        })
        .catch((error) => {
          // commit("updateShowTrackingShimmer", false);
          console.log("error in fetching status response: ", error);
        });
    },
    getActiveOrders({ commit, rootState, rootGetters }, payload) {
      const defaultHeaders = Headers();
      const pendingOrderFlowEnabled = rootState.Config?.appConfig?.config?.pendOrd || false;
      const orderSubmitInitiated = Utility.tryJsonParse(localStorage.getItem("orderSubmitInitiated") || "false");
      const pendingOrderRequired = pendingOrderFlowEnabled && orderSubmitInitiated;
      ApiCalls.GET_ACTIVE_ORDERS({
        headers: {
          ...defaultHeaders,
          pendingOrderRequired
        },
        payload,
      })
        .then((res) => {
          if (res?.data) {
            commit("updateActiveOrders", res?.data);
            if (res?.data?.pendingOrders?.length > 0) {
              const isPendingFlowValid = !!res.data?.pendingOrders[0]?.orderTransactionId;
              commit("updateShowPendingOrderModal", isPendingFlowValid);
            }
          }
        })
        .catch((error) => {
          console.log("error in fetching Active Orders", error);
        });
    },
    getTransactionConfirmation({ state, commit, dispatch, rootState }, payload) {
      try {
        const defaultHeaders = Headers();
        ApiCalls.TRANSACTION_API({
          headers: {
            ...defaultHeaders,
          },
          payload: {
            $transactionId: payload.urlParam.$transactionId,
          },
        }).then((response) => {
          switch (response.data.status) {
            case "WAIT":
              if (response.data.orderSummary) {
                payload.queryStringHash.fetchOrderSummaryOnWait = false;
                commit("saveOrderStatus", response.data);
              }
              payload.apiHitTime = payload.apiHitTime - payload.apiHitInterval;
              localStorageFunc.setLocalStorageValue(
                "ORDER_TRACKING_ID",
                response.data?.orderSummary?.id
              );
              if (payload.apiHitTime > 0) {
                setTimeout(() => {
                  dispatch("getTransactionConfirmation", payload);
                }, payload.apiHitInterval * 1000);
              } else {
                // after multiple hit send unknown response
                response.data.status = "UNKNOWN";
                localStorageFunc.setLocalStorageValue(
                  "TRANSACTION_STATUS",
                  response.data.status
                );
                commit("saveOrderStatus", response.data);
              }
              break;
            case "SUCCESS":
              localStorageFunc.setLocalStorageValue(
                "ORDER_TRACKING_ID",
                response.data?.orderSummary?.id
              );
              commit("saveOrderStatus", response.data);
              break;
            case "FAILED":
              const trackingId =
                response.data?.orderFailure?.encodedOrderId ||
                response.data?.orderSummary?.id;
              if (trackingId) {
                localStorageFunc.setLocalStorageValue(
                  "ORDER_TRACKING_ID",
                  trackingId
                );
                localStorageFunc.setLocalStorageValue(
                  "TOTAL_REFUND_AMT",
                  response.data?.orderFailure.totalRefund
                );
                commit("saveOrderStatus", response.data);
              } else {
                response.data.status = "UNKNOWN";
                localStorageFunc.setLocalStorageValue(
                  "TRANSACTION_STATUS",
                  response.data.status
                );
                commit("saveOrderStatus", response.data);
              }
              break;
            default:
              break;
          }
        });
      } catch (error) {
        commit("updateShowPendingOrderModal", false);
      }
    },
    sendDitaPickUpdate ({ commit, rootGetters, state }, payload) {
        const defaultHeaders = Headers()
        ApiCalls.DITA_PICK_USER_ACTION_API({
          headers: {
            ...defaultHeaders
          },
          payload: {
            orderId: payload.orderId,
            pickedUp: payload.pickedUp
          }
        })
          .then(res => {
            if (res?.data) {
              
            }
          })
          .catch(error => {
            commit('updateErrorModel', res?.error || 'Something went wrong')
          })
      },
  },
};
